import { BreadcrumbItem } from 'src/general/components/Breadcrumbs/Breadcrumbs.type';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';
import { formatMakeModelToUrlParam } from 'src/utils/plp/formatMakeModelToUrlParam';
import { getPlpUrlFromStoreFilters } from 'src/utils/plp/getPlpUrlFromStoreFilters';

export const generatePdpBreadcrumbs = (
  plpPagesMap: Map<string, string>,
  productDetailsPayload: ProductDetailsPayload,
): BreadcrumbItem[] => {
  const result: BreadcrumbItem[] = [
    { url: '/used-cars', label: 'Our cars' },
    {
      url: getPlpUrlFromStoreFilters(
        { makeModel: [formatMakeModelToUrlParam(productDetailsPayload.make)!] },
        {},
        plpPagesMap,
      ),
      label: productDetailsPayload.make,
    },
    {
      url: getPlpUrlFromStoreFilters(
        {
          makeModel: [formatMakeModelToUrlParam(productDetailsPayload.make, productDetailsPayload.model)!],
        },
        {},
        plpPagesMap,
      ),
      label: productDetailsPayload.model,
    },
  ];

  return result;
};
